module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_03.d183a107.jpg";